import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles((_theme) => ({
  containerInputRange: {
    marginTop: "0px !important",
  },
  modalHeader: {
    "& #modalHeader": {
      padding: "24px 24px 12px 24px",
      marginBottom: "24px",
      borderBottom: `1px solid ${colors.gray200}`,
    },
  },
}));

export default styles;

export const Wrapper = styled("div")(() => ({
  width: "100%",
}));

export const LiftvanGridContent = styled(Grid)(() => ({
  paddingRight: "0 !important",
}));

export const Title = styled("div")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const CheckboxContainer = styled("div")(() => ({
  display: "flex",
  height: "64px",
  paddingTop: "24px",
}));

export const LiftVanInfoIcon = styled("img")(() => ({
  marginLeft: "4px",
  marginTop: "12px",
}));
